module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/secondary_address.js
// module id = 900
// module chunks = 0